/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LayoutComponentHelper} from "../../components/util/layout-component-helper";

@Component({
  standalone: false,
  selector: 'layout-component-summary',
  template: `<div *ngFor="let out of output">{{out}}</div>`
})
export class LayoutComponentSummaryComponent implements OnInit {
  @Input() layout: Record<string, any>;
  output: Array<string>;

  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
    const summary = LayoutComponentHelper.getSummary(this.layout.layoutComponents);
    this.output = _.filter(_.map(summary, (val, key) => {
      return val > 0 ? val + " " + this.translate.instant('layout.fieldSummary.' + key + (val > 1 ? '.plural' : '')) : null;
    }), (val) => {
      return !!val;
    });
  }
}
